'use strict';

// Document signing — seal any file or text with the identity key into a portable, verifiable
// proof. A signed document is a DocumentSignature VC over the document's sha256 hash, so anyone
// can later confirm the EXACT file was signed by this identity (the file itself never leaves the
// device — only its hash is signed). Reuses the ES256K VC machinery.

const { subtle } = require('./lib');
const vcjwt = require('./vcjwt');

async function hashBytes(buf) {
  const bytes = buf instanceof Uint8Array ? buf : new Uint8Array(buf);
  const h = await subtle().digest('SHA-256', bytes);
  return [...new Uint8Array(h)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
function hashText(str) { return hashBytes(new TextEncoder().encode(String(str))); }

/** Sign a document hash into a DocumentSignature VC (ES256K). */
function signDocument({ did, privateKey, docHash, title, fileName, mimeType, version = 1 }) {
  return vcjwt.issueVc({
    issuerDid: did, kid: 'key-1', privateKey, subjectId: docHash, type: 'DocumentSignature',
    claims: { docHash, title: title || null, fileName: fileName || null, mimeType: mimeType || null, version, signedAt: Math.floor(Date.now() / 1000) },
  });
}

module.exports = { hashBytes, hashText, signDocument };
